import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/Z1.css";

// ⭐ Example 5 rows data – replace with your images, headings & text
import img1 from "../assets/images/item4/subitm1.jpg";
import img2 from "../assets/images/item4/subitm2.jpg";
import img3 from "../assets/images/item4/subitm3.jpg";
import img4 from "../assets/images/item4/subitm4.jpg";
import img5 from "../assets/images/item4/subitm5.jpg";

const rowsData = [
  {
    id: 1,
    title: "Hydraulic Valves",
    text: "Reliable hydraulic valves for precise control of fluid flow in hydraulic systems.",
    img: img1,
    gradient: "gradient1",
    stars: 4,
    description: `Hydraulic valves regulate the direction, pressure, and flow of hydraulic fluid in machinery. They are essential for the safe and efficient operation of industrial equipment. Made from high-quality materials to withstand high pressure and heavy-duty use.
`
  },
  {
    id: 2,
    title: "Filters",
    text: "High-performance filters to remove contaminants and protect hydraulic systems.",
    img: img2,
    gradient: "gradient2",
    stars: 5,
    description: `Filters ensure clean hydraulic fluid by removing dust, dirt, and other impurities. They improve system efficiency and extend the life of machinery. Durable construction provides reliable performance in demanding environments.
`
  },
  {
    id: 3,
    title: "Hydraulic Drum",
    text: "Sturdy hydraulic drums for safe storage and handling of hydraulic fluids.",
    img: img3,
    gradient: "gradient3",
    stars: 3,
    description: `Hydraulic drums are designed to store and transport hydraulic oils and lubricants safely. Built with strong materials to resist leaks and corrosion. Suitable for industrial and heavy-duty applications.
`
  },
  {
    id: 4,
    title: "Hydraulic Cylinders",
    text: "Durable hydraulic cylinders for powerful and precise linear motion.",
    img: img4,
    gradient: "gradient4",
    stars: 4,
    description: `Hydraulic cylinders convert hydraulic energy into mechanical force for heavy machinery. They provide powerful and controlled movement in industrial equipment. Manufactured with high-strength materials for long-lasting performance.
`
  },
  {
    id: 5,
    title: "Hydraulic Power Unit",
    text: "Efficient hydraulic power units for reliable energy supply to hydraulic machinery.",
    img: img5,
    gradient: "gradient5",
    stars: 5,
    description: `Hydraulic power units generate and supply pressurized fluid to hydraulic systems. They consist of pumps, motors, reservoirs, and valves for smooth operation. Designed for high performance and continuous heavy-duty use.
`
  }
];

function Z4() {
  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <>
      <Navbar />

      <section className="z1-section">
        {rowsData.map((row) => (
          <div
            key={row.id}
            className={`z1-row ${row.gradient}`}
            onClick={() => setSelectedRow(row)}
          >
            <div className="z1-img">
              <img src={row.img} alt={row.title} />
            </div>

            <div className="z1-content">
              <h2>{row.title}</h2>
              <p>{row.text}</p>
              <div className="stars">
                {"★".repeat(row.stars)}
                {"☆".repeat(5 - row.stars)}
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* 🔹 Popup / Modal */}
      {selectedRow && (
        <div className="z1-modal-overlay" onClick={() => setSelectedRow(null)}>
          <div
            className="z1-modal"
            onClick={(e) => e.stopPropagation()} // prevent close on inner click
          >
            <h2>{selectedRow.title}</h2>

            <div className="modal-body">
              <div className="modal-img">
                <img src={selectedRow.img} alt={selectedRow.title} />
              </div>
              <div className="modal-text">
                <p>{selectedRow.description}</p>
              </div>
            </div>

            <button
              className="close-btn"
              onClick={() => setSelectedRow(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

export default Z4;